// src/Components/IssueMultiSelect/IssueMultiSelect.jsx
import React from 'react';
import Select from 'react-select';

// The columns that might be "ISSUES DETECTED" or "NO ISSUES"
const issueColumns = [
  { value: 'Thermostat', label: 'Thermostat' },
  { value: 'Blower Fan', label: 'Blower Fan' },
  { value: 'Actuator', label: 'Actuator' },
  { value: '3 Way Valves', label: '3 Way Valves' },
  { value: 'Drain Pan', label: 'Drain Pan' },
  { value: 'Valves', label: 'Valves' },
  { value: 'Hoses', label: 'Hoses' },
  { value: 'Mould', label: 'Potential Mould' },
  { value: 'Coils', label: 'Coils' },
  { value: 'Compressor', label: 'Compressor' },
  { value: 'Glycol Leakage', label: 'Glycol Leakage' },
  { value: 'Leak Sensor', label: 'Leak Sensor' },
  { value: 'Insulation', label: 'Insulation' },
  { value: 'Other', label: 'Other' },
];

const customStyles = {
  control: (base) => ({
    ...base,
    backgroundColor: '#fff',
    borderRadius: '8px',
    border: 'none',
    boxShadow: '0 2px 6px rgba(0,0,0,0.1)',
    minHeight: '48px',
    ':hover': { border: 'none' },
  }),
  valueContainer: (base) => ({
    ...base,
    padding: '0 8px',
  }),
  multiValue: (base) => ({
    ...base,
    backgroundColor: '#eef6ff',
    borderRadius: '4px',
  }),
  multiValueLabel: (base) => ({
    ...base,
    color: '#1f5eec',
    fontWeight: 500,
  }),
  multiValueRemove: (base) => ({
    ...base,
    color: '#1f5eec',
    ':hover': {
      backgroundColor: '#cce0ff',
      color: '#1f5eec',
    },
  }),
  dropdownIndicator: (base) => ({
    ...base,
    color: '#999',
    ':hover': {
      color: '#666',
    },
  }),
  clearIndicator: (base) => ({
    ...base,
    color: '#999',
    ':hover': {
      color: '#666',
    },
  }),
};

function IssueMultiSelect({ issueFilters, setIssueFilters }) {
  // Convert the string filters into react-select options. The stored value can
  // differ from its display label (e.g. "Mould" shows as "Potential Mould").
  const selectedOptions = issueFilters.map(
    (val) => issueColumns.find((opt) => opt.value === val) || { value: val, label: val }
  );

  const handleChange = (selected) => {
    if (!selected) {
      setIssueFilters([]);
      return;
    }
    // Update our parent state with the new selected values
    setIssueFilters(selected.map((opt) => opt.value));
  };

  return (
    <Select
      aria-label="Filter by issues"
      isMulti
      options={issueColumns}
      value={selectedOptions}
      onChange={handleChange}
      placeholder="Filter By Issues..."
      styles={customStyles}
      closeMenuOnSelect={false}
      hideSelectedOptions={false}
    />
  );
}

export default IssueMultiSelect;
